import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function ProtectedRoute({ children, adminOnly = false, managerOrAdmin = false }) {
  const { user, loading } = useAuth();
  const loc = useLocation();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="text-muted-foreground font-heading text-sm tracking-wide">Loading…</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  // Force password reset gate — block all routes except the change-password page itself
  if (user.must_change_password === true && loc.pathname !== "/change-password") {
    return <Navigate to="/change-password?forced=1" replace />;
  }
  if (adminOnly && user.role !== "admin") return <Navigate to="/" replace />;
  if (managerOrAdmin && !["admin", "manager"].includes(user.role)) return <Navigate to="/" replace />;
  return children;
}
